import { type ColRowStyle, ColRowStyles } from './ColRowStyle';
import { BaseModel } from './baseModel';
import type { CellStyle } from './cellStyle';
import type { BaseStyle, Unit } from './types';

export class Row extends BaseModel {
  public heightOr(defaultValue: number): number {
    if (typeof this.height === 'number') {
      return this.height;
    }
    return defaultValue;
  }

  constructor(
    public readonly index: number,
    public readonly height: Unit = 'auto',
    public readonly style: ColRowStyles = new ColRowStyles(),
  ) {
    super();
  }

  public withHeight(height: Unit): Row {
    return new Row(this.index, height, this.style);
  }

  public withStyle(style: ColRowStyle): Row {
    return new Row(this.index, this.height, this.style.withStyle(style));
  }

  public cellStyleAt(index: number): BaseStyle<CellStyle> {
    return this.style.cellStyleAt(index);
  }
}
